import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

if (process.env.NODE_ENV === 'production') {
    console.log = () => { }
    console.error = () => { }
    console.debug = () => { }
}

ReactDOM.render(<Provider store={configureStore()}>
    <App />
</Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorkerRegistration.register({
    onUpdate: registration => {
        // Pergunta ao usuário se ele quer atualizar
        const waitingServiceWorker = registration.waiting;

        if (waitingServiceWorker) {
            const userConfirmation = window.confirm(
                "Uma nova versão está disponível! Deseja recarregar a página para atualizar?"
            );

            if (userConfirmation) {
                // Envia uma mensagem para o Service Worker para ele se ativar
                waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });

                // Recarrega a página assim que o novo Service Worker assumir o controle
                navigator.serviceWorker.addEventListener("controllerchange", () => {
                    window.location.reload();
                });
            }
        }
    },
});

